import type { PortableTextComponents } from 'next-sanity'

import { CheckListItem } from '@/app/components/CheckListItem'
import { cn } from '@/app/utils/style'

const defaultListLinkClasses = '[&_a]:text-white-950 [&_a]:underline'

export const createPortableTextLists = (
  listsClassName?: string,
): Pick<PortableTextComponents, 'list' | 'listItem'> => ({
  list: {
    bullet: ({ children }) => (
      <ul className="my-6xl flex flex-col gap-lg [&_ul]:mt-lg [&_ul]:ml-md [&_ul]:my-0 size-body-md text-white-800">
        {children}
      </ul>
    ),
    number: ({ children }) => (
      <ol className="my-6xl flex flex-col gap-lg [counter-reset:item] [&_ol]:mt-lg [&_ol]:ml-m md:[&_ol]:ml-md [&_ol]:my-0 [&_ol]:[counter-reset:item] size-body-md text-white-800">
        {children}
      </ol>
    ),
    checked: ({ children }) => (
      <ul className="my-6xl flex flex-col gap-lg [&_ul]:mt-lg [&_ul]:ml-md [&_ul]:my-0 size-body-md text-white-800">
        {children}
      </ul>
    ),
    checked_hero: ({ children }) => (
      <ul className="my-6xl flex flex-col gap-lg [&_ul]:mt-lg [&_ul]:ml-md [&_ul]:my-0 size-body-md text-white-800">
        {children}
      </ul>
    ),
  },
  listItem: {
    bullet: ({ children }) => (
      <li className={cn('flex gap-md', defaultListLinkClasses, listsClassName)}>
        <span className="text-paved-green-800 font-book">•</span>
        <span className="min-w-0 flex-1 break-words">{children}</span>
      </li>
    ),
    number: ({ children }) => (
      <li
        className={cn(
          "flex gap-md [counter-increment:item] before:content-[counter(item,lower-alpha)'.'] before:text-paved-green-800 before:font-book before:pt-[1px] [li_ol_&]:before:content-[counter(item,lower-roman)'.']",
          defaultListLinkClasses,
          listsClassName,
        )}
      >
        <span className="min-w-0 flex-1 break-words">{children}</span>
      </li>
    ),
    checked: ({ children }) => <CheckListItem size="m">{children}</CheckListItem>,
    checked_hero: ({ children }) => (
      <CheckListItem
        classNames={{
          container: 'self-center',
          text: 'self-start justify-start [&_p]:text-left max-w-[290px] lg:max-w-[340px]',
        }}
        size="hero"
      >
        {children}
      </CheckListItem>
    ),
  },
})
